export const CSS_CLASSES = {
	ACTIONS: 'root__card__actions',
	CONTAINER: 'root__container',
	PROFILE: 'profile--requestee',
	PROFILE_TITLE: 'profile--requestee__title',
	TITLE: 'title',
	TITLE_CONTAINER: 'title__container',
};
